import { NEW_ON_EDEL_DATA, NEW_ON_EDEL_SET_ERROR, NEW_ON_EDEL_HIDE_ERROR, NEW_ON_EDEL_START_LOADER, NEW_ON_EDEL_STOP_LOADER, } from "./../../interfaces/Home/iNewOnEdel";
const initialState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const newOnEdel = (state = initialState, action) => {
    switch (action.type) {
        case NEW_ON_EDEL_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case NEW_ON_EDEL_SET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case NEW_ON_EDEL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case NEW_ON_EDEL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case NEW_ON_EDEL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default newOnEdel;
